
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import BeerScreen from './beer'
import CategoriesScreen from './categories';
import SignatureCocktailsScreen from './sigatureCocktails';
import EventsScreen from './events';
import Cocktails from './cocktails';

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();

        const {change} = useRefresh();
    
    const [menus, setMenus] = useState([]);
    const [showmargaritas, setshowmargaritas] = useState(false);

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCoctatik, setshowCoctatik] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [beers, setbeers] = useState(false);
    const [signatureCocktails, setsignatureCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

    const Card = ({ image, label, onClick }) => (
        <div
            onClick={onClick}
            style={{
                width: '36%',
                borderRadius: 18,
                overflow: 'hidden',
                position: 'relative',
              
                cursor: 'pointer',
                height: 270,
            }}
        >
            <img
                src={image}
                onContextMenu={(e) => e.preventDefault()}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    pointerEvents: 'none',
                }}
            />
            
        </div>
    );

        
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 565) {
                setshowCoctatik(item);
            }
                 if (item.id === 564) {
                setbeers(item);
            }
           
            });
      }, [menus]);
    
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div style={{padding: '0 20px'}}>
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom: 20, marginTop: -50}}>
                        <img
                            src={require('./assets/logo.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width:320, height: 130, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                    </div>

                    <div style={{marginTop: 10}}>
                        <img
                            src={require('../../components/layouts/content2/assets/bannerCocktIL.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 400, objectFit: 'contain', borderRadius: 18, pointerEvents: 'none'}}
                        />
                    </div>

                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 16, gap: 10}}>
                        <Card
                            image={require('../../components/layouts/content2/assets/signatureCoctacil.png')}
                            label="Signature Cocktails"
                            onClick={() => {
                                setsignatureCocktails(true);
                            }}
                        />
                        <Card
                            image={require('../../components/layouts/content2/assets/frozenCocktail.png')}
                            label="Frozen Cocktails"
                            onClick={() => {
                               // setshowmargaritas(true);
                            }}
                        />
                        <Card
                            image={require('../../components/layouts/content2/assets/clasicCocktail.png')}
                            label="Classic Cocktails"
                            onClick={() => {
                               // setdishs(beers);
                               // setShowListProduct(true);
                            }}
                        />
                    </div>
                </div>
                                        
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showBeers && <BeerScreen setShowHappy={setshowBeers} />}
                {signatureCocktails && <SignatureCocktailsScreen setShowHappy={setsignatureCocktails} />}
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;